import Vue from 'vue'
import Router from 'vue-router'
// in development env not use Lazy Loading,because Lazy Loading too many pages will cause webpack hot update too slow.so only in production use Lazy Loading
/* layout */
import Layout from '../views/layout/Layout'
import fa from "element-ui/src/locale/lang/fa";

const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)
export const constantRouterMap = [
  {path: '/login', component: _import('login/index'), hidden: true},
  {path: '/loginsms', component: _import('login/smscode'), hidden: true},
  {path: '/register', component: _import('login/register'), hidden: true},
  {path: '/reset', component: _import('login/reset'), hidden: true},
  {path: '/resetpwd', component: _import('login/resetpwd'), hidden: true},
  {path: '/404', component: _import('404'), hidden: true},
  {path: '/customers', component: _import('yingliu/customers'), hidden: true},
  {path: '/sharecharts',  component: _import('yingliu/sharecharts'), hidden: true},
  {path: '/shareuserlist',  component: _import('yingliu/shareUserList'), hidden: true},
  {path: '/showpage',  component: _import('landingpage/showpage'), hidden: true},
  {
    path: '/',
    component: Layout,
    redirect: '/uvlist',
    name: 'uvlsit',
    hidden: true,

  },

]
export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})
export const asyncRouterMap = [

  {
    path: '',
    component: Layout,
    meta: {title: '统计图表', icon: 'table'},
    children: [
      {
        path: 'uvchart',
        name: '统计图表',
        isShow:true,
        component: _import('uv/charts'),
        meta: {title: '统计图表', icon: 'table'},
        menu: 'uvchart',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: 'UV列表', icon: 'home'},
    children: [
      {
        path: 'uvlist',
        name: 'UV列表',
        isShow:true,
        component: _import('uv/uvlist'),
        meta: {title: 'UV列表', icon: 'home'},
        menu: 'uvlist',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: '渠道列表', icon: 'tree'},
    children: [
      {
        path: 'channellist',
        name: '渠道列表',
        isShow:true,
        component: _import('uv/channellist'),
        meta: {title: '渠道列表', icon: 'example'},
        menu: 'channellist',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: '用户列表', icon: 'user'},
    children: [
      {
        path: 'uvuser',
        name: '用户列表',
        isShow:true,
        component: _import('uv/users'),
        meta: {title: '用户列表', icon: 'user'},
        menu: 'uvuser',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: '充值记录', icon: 'user'},
    children: [
      {
        path: 'addtokenlog',
        name: '充值记录',
        isShow:true,
        component: _import('uv/addtokenlog'),
        meta: {title: '充值记录', icon: 'user'},
        menu: 'addtokenlog',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: 'USDT充值记录', icon: 'user'},
    children: [
      {
        path: 'usdtchargelog',
        name: 'USDT充值记录',
        isShow:true,
        component: _import('uv/usdtchargelog'),
        meta: {title: 'USDT充值记录', icon: 'user'},
        menu: 'addtokenlog',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: '分流排行', icon: 'user'},
    children: [
      {
        path: 'clickrank',
        name: '分流排行',
        isShow:true,
        component: _import('uv/clickrank'),
        meta: {title: '分流排行', icon: 'user'},
        menu: 'clickrank',

      },

    ]
  },


  {
    path: '',
    component: Layout,
    meta: {title: '发送消息', icon: 'user'},
    children: [
      {
        path: 'sendtgmsg',
        name: '发送消息',
        isShow:true,
        component: _import('msg/tgmsg'),
        meta: {title: '发送消息', icon: 'user'},
        menu: 'sendtgmsg',

      },

    ]
  },


  {
    path: '',
    component: Layout,
    meta: {title: '定制域名', icon: 'tree'},
    children: [
      {
        path: 'customerdomain',
        name: '定制域名',
        isShow:true,
        component: _import('uv/customerdomains'),
        meta: {title: '定制域名', icon: 'tree'},
        menu: 'customerdomain',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: '客服Bot', icon: 'tree'},
    children: [
      {
        path: 'vipbot',
        name: '客服Bot',
        isShow:true,
        component: _import('uv/VipBot'),
        meta: {title: '客服Bot', icon: 'tree'},
        menu: 'vipbot',

      },

    ]
  },

  {
    path: '',
    component: Layout,
    meta: {title: 'BotManager', icon: 'tree'},
    children: [
      {
        path: 'botManager',
        name: 'BotManager',
        isShow: true,
        component: _import('botManager/index'),
        meta: {title: 'BotManager', icon: 'tree'},
        menu: 'botManager',
      }
    ]
  },





  {path: '*', redirect: '/404', hidden: true}
]
